import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanActivateChild,
  CanDeactivate
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';
import { DashboardComponent } from './dashboard/dashboard.component';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanDeactivate<DashboardComponent> {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.isAuthenticated()
      .then(
        (authenticated: boolean) => {
          if (authenticated) {
            return true;
          } else {
            this.router.navigate(['/']);
          }
        }
      );
  }

  canActivateChild(route: ActivatedRouteSnapshot,
                   state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(route, state);
  }
  canDeactivate(component : DashboardComponent,currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot){
    return false

  }
}



// WEBPACK FOOTER //
// ./src/app/auth-guard.service.ts